import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Action from '../../../actions/AdminSettingSeminarRoom';
import SettingSeminarRoomPage from '../../../pages/Admin/SettingSeminarRoom/SettingSeminarRoomPage';
import withAuth from '../../../common/WithAuth';

const mapStateToProps = (state) => {
    const isLoading = state.adminSettingSeminarRoom.get.isFetching
    || state.adminSettingSeminarRoom.update.isFetching;
    return ({
        locale: state.locale.lang.current,
        settingSeminarRoomData: state.adminSettingSeminarRoom.get.data,
        errors: state.adminSettingSeminarRoom.update.errors,
        isCompleted: state.adminSettingSeminarRoom.update.isCompleted,
        isLoading,
        eventInfo: state.eventManagement.infoEvent.data,
    });
};

const mapDispatchToProps = (dispatch) => ({
    getSettingSeminarRoom: (eventShortName) => dispatch(Action.getSettingSeminarRoomRequested(eventShortName)),
    updateSettingSeminarRoom: (eventShortName, body) => dispatch(Action.updateSettingSeminarRoomRequested({ eventShortName, body })),
    getSettingSeminarRoomClear: () => dispatch(Action.getSettingSeminarRoomClear()),
    updateSettingSeminarRoomClear: () => dispatch(Action.updateSettingSeminarRoomClear()),
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(SettingSeminarRoomPage);
